import React from 'react';
import '../styles/Home.css';
import { HomeGrid } from '../components/HomeGrid';
import { teams_list } from '../constants/teams'
import { Header } from '../components/Header';
import SearchBox from '../components/SearchBox';
import { Footer } from '../components/Footer';

export const Home = () => {

    return (
        <div className="home-page">
            <Header 
                title = "2023 Fifa Women's World Cup Teams" 
                isSquadPage = {false} />
            <SearchBox/>
            <HomeGrid teams={teams_list} />
            <Footer/>
        </div>
    );
};